import { render, staticRenderFns } from "./DeclaracaoPlanoConta.vue?vue&type=template&id=78c63d6e&scoped=true&"
import script from "./DeclaracaoPlanoConta.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoPlanoConta.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoPlanoConta.vue?vue&type=style&index=0&id=78c63d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c63d6e",
  null
  
)

export default component.exports